import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { IntersectionService } from '@core/services/intersection.service';
import { ParallaxService } from '@features/parallax/parallax.service';

@Directive({
    selector: '[appParallaxElement]',
    standalone: true
})
export class ParallaxElementDirective implements OnInit, OnDestroy {
    private intersectionKey = 'intersectionParallax';

    private unsubscribe = new Subject<void>();

    @Input()
    private travel = 200;

    @Input()
    private dullness = 5;

    @Input()
    private easeOut = true;

    constructor(
        private element: ElementRef<HTMLElement>,
        private parallaxService: ParallaxService,
        private intersectionService: IntersectionService
    ) {}

    ngOnInit(): void {
        if (this.easeOut) {
            this.element.nativeElement.style.transition = `transform 0.15s ease-out`;
        }
        this.intersectionService
            .observe(this.intersectionKey, this.element.nativeElement)
            .pipe(
                takeUntil(this.unsubscribe),
                filter((entry: IntersectionObserverEntry) => entry.target === this.element.nativeElement)
            )
            .subscribe(entry => {
                if (entry.isIntersecting) {
                    this.parallaxService.startParallax({
                        element: entry.target as HTMLElement,
                        travel: this.travel,
                        dullness: this.dullness
                    });
                    return;
                }

                this.parallaxService.stopParallax(entry.target);
            });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
